angular.module('impactx.manualordercreation').service('ManualOrderCreationService', [
    '$mdDialog',
    'dataGen',
    '$redirect',
    '$context',
    ManualOrderCreationService
]);

function ManualOrderCreationService($mdDialog, dataGen, $redirect, $context) {

    function openCreationDialogInternal(event) {
        $mdDialog.show({
            controller: "ManualOrderCreationDialogCtrl",
            controllerAs: "manualOrderCreationDialogCtrl",
            templateUrl: "modules/manualordercreation/templates/manualordercreationdialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false
        });
    }

    function openCreationDialog (event) {
        var mainData = {};
        dataGen.getData(mainData, {}, "/purchaseorder/manualordercreation/dialog").then(function () {
            var companyEntryPoint = mainData.data.canSelectUser ? "/purchaseorder/manualordercreation/company/admin" : "/purchaseorder/manualordercreation/company/own";
            dataGen.getData({}, {}, companyEntryPoint).then(function (data) {
                if (data.data.entries.length === 1) {
                    var company = data.data.entries[0];
                    if (mainData.data.canSelectUser) {
                        dataGen.getData({}, {orderingCompanyId: company.id}, "/purchaseorder/manualordercreation/user").then(function (data) {
                            if (data.data.entries.length === 1) {
                                var user = data.data.entries[0];
                                dataGen.getData({}, {orderingCompanyId: company.id, orderingUserId: user.id},
                                    "/purchaseorder/manualordercreation/contract").then(function (data) {
                                    if (data.data.entries.length === 1) {
                                        var contract = data.data.entries[0];
                                        $redirect.redirectTo(null, "/manualordercreation/" + company.id + "/" +
                                            user.id + "/" + contract.id);
                                    }
                                    else {
                                        openCreationDialogInternal(event);
                                    }
                                })
                            }
                            else {
                                openCreationDialogInternal(event);
                            }
                        });
                    }
                    else {
                        var userId = $context.userId.value;
                        dataGen.getData({}, {orderingCompanyId: company.id, orderingUserId: userId},
                            "/purchaseorder/manualordercreation/contract").then(function (data) {
                            if (data.data.entries.length === 1) {
                                var contract = data.data.entries[0];
                                $redirect.redirectTo(null, "/manualordercreation/" + company.id + "/" +
                                    userId + "/" + contract.id);
                            }
                            else {
                                openCreationDialogInternal(event);
                            }
                        })
                    }
                }
                else {
                    openCreationDialogInternal(event);
                }
            });
        });
    }

    return {
        openCreationDialog: openCreationDialog
    };
}
